import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import styles from "../../../Transcript/SchedulePDFStyles";
import {
  formattedStartAndEndDate,
  formatInstructorName,
} from "../../../Transcript/SchedulePDFUtils";

const SchedulePDFHeader = ({
  minDate,
  maxDate,
  firstName,
  lastName,
  userName,
  dob,
}) => (
  <View style={styles.header}>
    <Image style={styles.logo} src="/Logo.png" />

    {/* <Text style={styles.companyText}>
            SEIU 775 Benefits Group{'\n'}
            215 Columbia St #300, Seattle, WA 98104
          </Text> */}
    <View
      style={[
        styles.headerTwoColumn,
        { justifyContent: "center", alignItems: "center",top:-14 },
      ]}
    >
      <Text style={{ fontWeight: 'bold',fontSize:12 }}> UPCOMING CLASS SCHEDULE </Text>
    </View>
    <View  style={[
        styles.headerTwoColumn,
        { justifyContent: "center", alignItems: "center",top:-14 },
      ]}>
            <Text style={{ fontSize: 6 }}>Last updated on {(() => { const d = new Date(); d.setDate(d.getDate() - 1); return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`; })()} 11:30 AM.</Text>
    </View>
    <View
      style={{ borderBottomWidth: 1, borderColor: "#000", marginVertical: 5,top:-14 }}
    />

    <View style={[styles.headerTwoColumn,{top:-14 }]}>
      <View style={styles.hedaerColumn1}>
        <Text style={{fontSize:9,color:'#333',fontWeight: 'bold' }}> Student Name: </Text>
       <Text style={{fontSize:9,color:'#333'}}> {firstName} {lastName}</Text>
      </View>
      <View style={[styles.hedaerColumn2, { alignSelf: "flex-end" }]}>
        {" "}
        <Text style={{fontSize:9,color:'#333',fontWeight: 'bold' }}> Student Id: </Text>
          <Text style={{fontSize:9,color:'#333'}}> {userName}</Text>
      </View>
    </View>
  </View>
);

export default SchedulePDFHeader;
